module.exports = __webpack_public_path__ + "img/emmis.1eb48a18.png";